var exports = {
  "al": "xaee3c4fa--3c0f8b--unsubscribe",
  "wI": "xaee3c4fa--3c0f8b--unsubscribe-content",
  "b": "xaee3c4fa--3c0f8b--unsubscribe_title",
  "hz": "xaee3c4fa--3c0f8b--unsubscribe_info",
  "P7": "xaee3c4fa--3c0f8b--unsubscribe_email",
};

module.exports = exports;
